import axios from 'axios';

export const parsePublicAPIArray = <T>(value: T[] | T | undefined | null): T[] => {
  if (value === undefined || value === null) {
    return [];
  }
  return !Array.isArray(value) ? [value] : value;
};

export const fetchAllPublicAPI = async <T>(
  entityName: string,
  url: string,
  config: Record<string, any> = {},
  accumulated: T[] = []
): Promise<T[]> => {
  const response = await axios.get(url, config);
  const acc = [...accumulated, ...parsePublicAPIArray(response.data[entityName])];
  const next = response.data?.['@attributes']?.next;
  if (next) {
    const nextUrl = new URL(next);
    nextUrl.protocol = window.location.protocol;
    nextUrl.host = window.location.host;
    return fetchAllPublicAPI(entityName, nextUrl.toString(), config, acc);
  }
  return acc;
};

export const fetchAllByIDsPublicAPI = async <T>(
  IDs: number[],
  entityName: string,
  url: string,
  config: Record<string, any> = {},
  accumulated: T[] = []
): Promise<T[]> => {
  if (IDs.length === 0) return accumulated;
  const fetchingIDs = IDs.slice(0, 100);
  const remainingIDs = IDs.slice(100);
  const response = await axios.get(url.replace('%s', fetchingIDs.join(',')), config);
  const acc = [...accumulated, ...parsePublicAPIArray(response.data[entityName])];
  if (remainingIDs.length > 0) {
    return fetchAllByIDsPublicAPI(remainingIDs, entityName, url, config, acc);
  }
  return acc;
};
